import React, { Component } from 'react';
import Notice from "Components/Notice";
import { GetQuery } from "Pub/js/utils";
import { withRouter } from "react-router-dom";
import Ajax from "Pub/js/ajax";
import SideCard from './SideCard';
import SiderContent from '../../LeftSider/SiderContent';
import _ from "lodash";
import { getCardList, getRelateidObj, getResponParams, getQueryCloud } from '../../utilService';
import { getCloudMenus, getMenus } from "Pub/js/allApps";
class MySide extends Component {
    constructor(props) {
        super(props);
        this.urlRequestObj = GetQuery(this.props.location.search);
        this.relateidObj = getRelateidObj(
            this.urlRequestObj.pk_responsibility,
            this.urlRequestObj.is_group,
            this.urlRequestObj.workbenchid,
        );
        this.responsibilityParams = getResponParams(this.relateidObj, this.props.location.search);
        this.state = { domainArr: [] };
    }
    componentDidMount() {
        this.getDomainArr();
    }
    // 搜索
    onSearch = searchValue => {
        if (searchValue === "") {
            return;
        }
        let ajaxData = {
            search_content: searchValue,
            apptype: "1",
            ...this.responsibilityParams,
        };

        Ajax({
            url: `/nccloud/platform/appregister/searchmenuitem.do`,
            info: {
                name: this.props.json[
                    "DesktopSetting-000004"
                ] /* 国际化处理： 工作桌面配置*/,
                action: this.props.json[
                    "DesktopSetting-000029"
                ], /* 国际化处理： 模糊搜索应用和部件*/
            },
            data: ajaxData,
            loading: true,
            success: res => {
                const { data, success } = res.data;
                if (
                    success &&
                    data &&
                    data.children &&
                    data.children.length
                ) {
                    data.children.forEach((item => {
                        item.checked = false;
                    }));
                    this.setState({ appGroupArr: [data], isAllShow: true });
                } else {
                    if (data && data.children && data.children.length === 0) {
                        this.setState({ appGroupArr: [], isAllShow: true });
                    } else {
                        Notice({ status: "error", msg: data });
                    }
                }
            },
        });
    };
    // 领域模块搜索
    cascadeOnChange = (value, selectedOptions) => {
        let cascadeValueArr = value;
        if (cascadeValueArr && cascadeValueArr.length === 0 && cascadeValueArr.length === 1) {
            return;
        }

        let ajaxData = {
            own_module: cascadeValueArr[value.length - 1],
            apptype: '1',
            ...this.responsibilityParams,
        };

        //云应用传is_cloud_app
        if (selectedOptions && selectedOptions.length) {
            const selectedModule = selectedOptions[value.length - 1];
            ajaxData = {
                ...ajaxData,
                is_cloud_app: selectedModule.is_cloud_app,
            };
        }
        // bip菜单是否要请求
        const queryUrl = this.props.location && this.props.location.search;
        ajaxData = { ...ajaxData, ...getQueryCloud(queryUrl) };

        getMenus({
            info: {
                name: this.props.json[
                    "DesktopSetting-000004"
                ] /* 国际化处理： 工作桌面配置*/,
                action: this.props.json[
                    "DesktopSetting-000030"
                ], /* 国际化处理： 查询模块下应用和部件*/
            },
            data: ajaxData,
        }).then(data => {
            if (data && data.length) {
                this.setState({
                    appGroupArr: data,
                    isAllShow: true,
                    domainModuleSelect: value,
                });
            } else {
                if (data && data.length === 0) {
                    this.setState({
                        appGroupArr: [],
                        isAllShow: true,
                        domainModuleSelect: value,
                    });
                } else {
                    Notice({ status: "error", msg: data });
                }
            }
        })
    }

    // 获取数据接口
    getDomainArr = () => {
        let ajaxData = this.responsibilityParams;
        // bip菜单是否要请求
        const queryUrl = this.props.location && this.props.location.search;
        ajaxData = { ...ajaxData, ...getQueryCloud(queryUrl) };
        const info = {
            name: this.props.json[
                "DesktopSetting-000004"
            ] /* 国际化处理： 工作桌面配置*/,
            action: this.props.json[
                "DesktopSetting-000027"
            ], /* 国际化处理： 查询一二级领域模块*/
        }
        Promise.all([
            getMenus({
                info,
                data: ajaxData,
                loading: true,
            }),
            getCloudMenus({
                info
            })
        ]).then(([menuData, cloudMenuData]) => {
            const data = [...menuData, ...cloudMenuData];
            if (data.length) {
                const domainModuleSelect = [
                    data[0].value,
                    data[0].children[0].value,
                ];
                this.cascadeOnChange(domainModuleSelect);
                this.setState({
                    domainArr: data,
                    domainModuleSelect: domainModuleSelect,
                });
            } else {
                if (data.length === 0) {
                    Notice({
                        status: "warning",
                        msg: this.props.json[
                            "DesktopSetting-000028"
                        ], /* 国际化处理： 领域模块数据为空*/
                    });
                } else {
                    Notice({ status: "error", msg: data });
                }
            }
        })
    }

    //重置已选的卡片
    resetSelectedCards = () => {
        let appGroupArr = _.cloneDeep(this.state.appGroupArr);
        appGroupArr.forEach(item => {
            item.children.forEach(currentValue => {
                if (currentValue.checked) {
                    currentValue.checked = false;
                }
                item.checkedAll = false;
                item.indeterminate = false;
            });
        });
        this.setState({ appGroupArr });
    }

    //每组的全选与否
    onCheckChange = (e, index) => {
        const checked = e.target.checked;
        let { appGroupArr } = this.state;
        let selectGroup = appGroupArr[index];

        selectGroup.checkedAll = checked;
        selectGroup.indeterminate = false;
        selectGroup.children.forEach(item => {
            item.checked = checked;
        });
        getCardList(appGroupArr);
        this.setState({ appGroupArr });
    };
    // 单个卡片选择
    onChangeChecked = (checked, groupIndex, index) => {
        let appGroupArr = _.cloneDeep(this.state.appGroupArr);
        let selectGroup = appGroupArr[groupIndex];
        let child = selectGroup.children[index];
        child.checked = checked;

        let checkCount = 0;
        selectGroup.children.forEach(item => {
            if (item.checked) {checkCount++;}
        });

        selectGroup.checkedAll = checkCount === selectGroup.children.length;
        selectGroup.indeterminate = checkCount < selectGroup.children.length;
        this.setState({ appGroupArr });
    };

    //分组全选
    handleCheckAllChange = data => {
        this.setState({ appGroupArr: data });
    };

    //分组显隐
    handleGroupShow = (groupIndex, isShow) => {
        let appGroupArr = _.cloneDeep(this.state.appGroupArr);
        if (appGroupArr[groupIndex]) {
            appGroupArr[groupIndex].isShow = isShow;
            this.setState({ appGroupArr });
        }
    }
    //渲染sideCard groupIndex：group的index searchValue：搜索关键字（高亮用）
    renderSideCard = (child, i, groupIndex) => {
        return (
            <SideCard
                key={child.value}
                id={child.value}
                width={child.width}
                height={child.height}
                index={i}
                parentIndex={groupIndex}
                // searchValue={searchValue}
                name={child.label}
                appGroupArr={this.state.appGroupArr}
                onChangeChecked={this.onChangeChecked}
                checked={child.checked}
                resetSelectedCards={this.resetSelectedCards}
                cardList={this.props.cardList}
                card={child}
            />
        );
    }
    render() {
        const { appGroupArr, domainArr, domainModuleSelect } = this.state;
        return (
            <div className="box-l">
                <SiderContent
                    json={this.props.json}
                    contentData={appGroupArr}
                    defaultCascaderValue={domainModuleSelect}
                    cascaderOptions={domainArr}
                    onSearch={this.onSearch}
                    onCascaderChange={this.cascadeOnChange}
                    onCheckAllChange={this.handleCheckAllChange}
                    onChangeChecked={this.onCheckChange}
                    onGroupShowChange={this.handleGroupShow}
                    resetSelectedCards={this.resetSelectedCards}
                    renderSideCard={this.renderSideCard}
                />
            </div>
        );
    }
}

export default withRouter(MySide);
